import * as R from 'ramda';

/**
 * Helper for iterating over an object and outputting to JSX.
 * @param {Function} fn The render function.
 * @param {Object} collection
 * @returns {Array} An array of elements to render.
 */
const entryLoop = (fn, collection) => (
  R.pipe(
    R.map(fn),
    R.values,
  )(collection)
);

export default entryLoop;

